// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-toggle-btn {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

.theme-toggle-btn:hover {
  background: var(--bg-glass-hover);
  border-color: rgba(255, 255, 255, 0.08);
}

.theme-toggle-track {
  position: relative;
  width: 42px;
  height: 24px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-subtle);
  border-radius: 12px;
  transition: all 0.3s ease;
  box-shadow: inset 0 2px 4px rgba(0,0,0,0.2);
}

.is-light .theme-toggle-track {
  background: var(--accent-emerald);
  border-color: var(--accent-emerald);
  box-shadow: inset 0 2px 4px rgba(0,0,0,0.1);
}

.theme-toggle-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  box-shadow: 0 1px 3px rgba(0,0,0,0.3);
}

.is-light .theme-toggle-thumb {
  transform: translateX(18px);
}

.theme-toggle-icon {
  color: var(--bg-primary);
  display: flex;
  align-items: center;
  justify-content: center;
}

.theme-toggle-label {
  font-family: var(--font-sans);
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--text-secondary);
  transition: color 0.2s ease;
}

.theme-toggle-btn:hover .theme-toggle-label {
  color: var(--text-primary);
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui/src/ThemeToggle.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,qCAAqC;EACrC,sCAAsC;EACtC,+BAA+B;EAC/B,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,sCAAsC;EACtC,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4DAA4D;EAC5D,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".theme-toggle-btn {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 8px 12px;\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.theme-toggle-btn:hover {\n  background: var(--bg-glass-hover);\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n.theme-toggle-track {\n  position: relative;\n  width: 42px;\n  height: 24px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-subtle);\n  border-radius: 12px;\n  transition: all 0.3s ease;\n  box-shadow: inset 0 2px 4px rgba(0,0,0,0.2);\n}\n\n.is-light .theme-toggle-track {\n  background: var(--accent-emerald);\n  border-color: var(--accent-emerald);\n  box-shadow: inset 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.theme-toggle-thumb {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 18px;\n  height: 18px;\n  background: #fff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n  box-shadow: 0 1px 3px rgba(0,0,0,0.3);\n}\n\n.is-light .theme-toggle-thumb {\n  transform: translateX(18px);\n}\n\n.theme-toggle-icon {\n  color: var(--bg-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.theme-toggle-label {\n  font-family: var(--font-sans);\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--text-secondary);\n  transition: color 0.2s ease;\n}\n\n.theme-toggle-btn:hover .theme-toggle-label {\n  color: var(--text-primary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
